import { RadioGroup, RadioGroupProps, Tooltip, Typography } from '@mui/material';
import clsx from 'clsx';
import { Control, Controller, FieldValues, Path, PathValue } from 'react-hook-form';

type IProps<ControlData extends FieldValues = FieldValues> = {
  id: Path<ControlData>;
  label?: string;
  tooltip?: string;
  labelClassName?: string;
  defaultValue?: PathValue<ControlData, Path<ControlData>>;
  children: React.ReactNode;
  control: Control<ControlData>;
} & RadioGroupProps;

const FormRadioGroup = <T extends FieldValues = FieldValues>(props: IProps<T>) => {
  const { id, label, labelClassName, defaultValue, children, control, tooltip, ...rest } = props;

  return (
    <>
      {!!label && (
        <Tooltip title={tooltip || ''} placement="bottom-start">
          <Typography className={clsx('font-500 tracking-tight leading-tight', labelClassName)}>
            {label}
          </Typography>
        </Tooltip>
      )}

      <Controller
        render={({ field }) => (
          <Tooltip title={tooltip && !label ? tooltip : ''} placement="bottom-start">
            <RadioGroup className="flex flex-row gap-10" {...field} {...rest}>
              {children}
            </RadioGroup>
          </Tooltip>
        )}
        name={id}
        control={control}
        defaultValue={defaultValue}
      />
    </>
  );
};

export default FormRadioGroup;
